
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"foreign","xmlns":"http://www.w3.org/2000/svg","width":"11.245","height":"11.245","viewBox":"0 0 11.245 11.245"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_2350","data-name":"Group 2350","transform":"translate(4.089)"}},[_c('g',{attrs:{"id":"Group_2349","data-name":"Group 2349"}},[_c('path',{attrs:{"id":"Path_467","data-name":"Path 467","fill":"currentColor","d":"M192.827,0h-4.089a.511.511,0,1,0,0,1.022h2.855l-5.261,5.261a.511.511,0,1,0,.723.723l5.261-5.261V4.6a.511.511,0,0,0,1.022,0V.511A.511.511,0,0,0,192.827,0Z","transform":"translate(-186.182)"}})])]),_c('g',{attrs:{"id":"Group_2352","data-name":"Group 2352","transform":"translate(0 2.045)"}},[_c('g',{attrs:{"id":"Group_2351","data-name":"Group 2351"}},[_c('path',{attrs:{"id":"Path_468","data-name":"Path 468","fill":"currentColor","d":"M8.689,96.158a.511.511,0,0,0-.511.511v4.6H1.022V94.113h4.6a.511.511,0,1,0,0-1.022H.511A.511.511,0,0,0,0,93.6v8.178a.511.511,0,0,0,.511.511H8.689a.511.511,0,0,0,.511-.511V96.669A.511.511,0,0,0,8.689,96.158Z","transform":"translate(0 -93.091)"}})])])])
          )
        }
      }
    